import { usePortalVersion } from '../../contexts/PortalVersionContext.jsx';

/**
 * PortalVersionToggle — switch between V1 (classic) and V2 (modern) portal.
 * Accepts a `variant` prop to style itself for each navigation context.
 *
 * Phase 2: V2 is the default. The V1 variant renders only when a user has
 * explicitly rolled back to classic, and offers them a path back to V2.
 *
 * @param {{ variant: 'v1' | 'v2' }} props
 */
const PortalVersionToggle = ({ variant = 'v1' }) => {
    const { togglePortalVersion } = usePortalVersion();

    if (variant === 'v2') {
        return (
            <button
                type="button"
                onClick={togglePortalVersion}
                className="nav2-version-toggle"
                title="Switch to classic portal"
            >
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
                </svg>
                Switch to Classic
            </button>
        );
    }

    // V1 variant — pill button in the classic sidebar that returns the user to V2
    return (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <button
                type="button"
                onClick={togglePortalVersion}
                className="btn btn-sm mt-2"
                style={{
                    background: 'linear-gradient(135deg, #0081c7 0%, #00a2fa 100%)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '20px',
                    padding: '6px 16px',
                    fontSize: 'var(--font-size-xs)',
                    fontWeight: '600',
                    cursor: 'pointer',
                    width: '75%',
                    transition: 'all 200ms ease',
                }}
                title="Switch to the new portal"
            >
                ✦ New Portal
            </button>
        </div>
    );
};

export default PortalVersionToggle;
